import InstructionIcon from 'assets/img/icons/instruction.svg';
import Button from 'components/_parts/atoms/button';
import Input from 'components/_parts/atoms/input';
import Label from 'components/_parts/atoms/label';
import { useFormik } from 'formik';
import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useDispatch } from 'react-redux';
import {
  HIT_WORKER_TYPE_CREATE,
  HIT_WORKER_TYPE_UPDATE,
} from 'redux/actions/wla';
import styled from 'styled-components';
import * as Yup from 'yup';
import './index.scss';
import { useUpdateLevelDescriptionMutation } from 'components/company/hooks/useCompany';
import validationSchema from './validationSchema';
import initialValues from './initialValues';

const FullScreenOverlay = styled.div`
  position: fixed;
  height: 100%;
  width: 100%;
  right: 0;
  right: 0;
  top: 0;
`;

const ButtonMod = styled(Button)`
  width: 100%;
  width: 92px;
  height: 40px;
  float: right;
`;
const ButtonInfo = styled(Button)`
  width: 100%;
  width: fit-content;
  height: 40px;
  min-width: 147px;
  border: 1px solid #3d5afe;
  background-color: #ffffff;
  color: #3d5afe;
  padding: 12px 16px;
  column-gap: 10px;
`;

function WorkerType(props) {
  const dispatch = useDispatch();
  const updateLevelDescriptionMutation = useUpdateLevelDescriptionMutation();
  const { t } = props;
  const formik = useFormik({
    initialValues,
    validationSchema: validationSchema({ type: props?.typeForm, t }),
    onSubmit: async (values) => {
      try {
        if (props.typeForm === 'edit') {
          await updateLevelDescriptionMutation.mutateAsync({
            data: values,
          });
        }
        props.funcModal(false);
        formik.resetForm();
      } catch (error) {
        props.funcModal(false);
        formik.resetForm();
      }
    },
    onChange: (e) => {
      formik.setFieldValue(e.target.name, e.target.value);
    },
  });
  useEffect(() => {
    if (props.typeForm === 'edit') {
      formik.setValues({
        ...formik.values,
        company_cust_jobdesc_id: props?.data?.company_cust_jobdesc_id,
        title: props?.data?.title,
        level: props?.data?.level,
      });
    }
  }, [props.data, props.typeForm]);
  return (
    <>
      {props?.modal
        && createPortal(
          <>
            <FullScreenOverlay className="cs_modal-bg" />
            <div
              className="cs_modal-container-activity-type d-flex justify-content-between flex-column"
              ref={props.innerRef}
            >
              <Label
                className="text-center"
                typeLabel="label_modal"
                style={{
                  fontSize: '16px',
                }}
              >
                {`${props?.typeForm === 'edit' ? t('org.structure_view.modal.edit') : t('org.structure_view.modal.add')} ${t('org.component.lvl_desc')}`}
              </Label>
              <div className="cs_modal-worktype">
                <div>
                  <Input
                    isError={
                      formik.touched.title && Boolean(formik.errors.title)
                    }
                    validateMessage={formik.errors.title}
                    type="text"
                    name="title"
                    onChange={formik.handleChange}
                    value={formik.values.title || ''}
                    placeholder={t('biz_process.tree.title')}
                  />
                </div>
              </div>
              <div className="d-flex justify-content-end">
                <ButtonMod
                  func={(e) => {
                    formik.handleSubmit(e);
                    setTimeout(() => {
                      props.funcId(null);
                    }, 1000);
                  }}
                >
                  {t('board.save')}
                </ButtonMod>
              </div>
            </div>
          </>,
          document.getElementById('list_desc'),
        )}
    </>
  );
}

export default WorkerType;
